import { EPlatform, EPlatformType } from '@/lib/enums';
import { useMutation } from '@tanstack/react-query';

import { API_ROUTES } from './apiRoutes';
import useAxios from './useAxios';

const { post } = useAxios();

export interface OtpData {
  publisherId: string;
  device: 'DESKTOP' | 'APPCHARGE';
  platform: string;
  utm?: {
    utmSource: string;
    utmMedium: string;
    utmCampaign: string;
    payload?: string;
  };
  redirectUrl?: string;
  metadata?: Record<string, string>;
}

const getOtp = async (data: OtpData): Promise<any> => {
  const response = await post(`${API_ROUTES.OTP}`, {
    data: {
      ...data,
      redirectUrl: window.location.origin
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });

  return response.data;
};

export const useOtp = () => {
  const getOtpMutation = useMutation({
    mutationFn: getOtp
  });

  return {
    getOtpMutation
  };
};
